<template>
  <span>
    <slot>
      <b-button class="ml-2" size="sm" variant="danger" @click="downloadPdf"> PDF </b-button>
    </slot>
  </span>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  props: {
    docDefinition: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    downloadPdf() {
      pdfMake.createPdf(this.docDefinition).download();
    }
  }
};
</script>

<style></style>
